export interface IFrameInitMessage {
  action: 'init';
  hostRelativeRef: string;
  autostartRef: string | null;
  isReload: boolean;
}
